export default "__VITE_ASSET__DSjBPsnZ__"